import { Song } from "../@core/models";

const DB_NAME = "aryn-offline";
const DB_VERSION = 1;
const SONGS_STORE = "songs";

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(SONGS_STORE)) {
        db.createObjectStore(SONGS_STORE, { keyPath: "id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function saveSongsToDB(songs: Song[]): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(SONGS_STORE, "readwrite");
    const store = tx.objectStore(SONGS_STORE);
    store.clear();
    songs.filter((s) => s.id !== null && s.id !== undefined).forEach((song) => store.put(song));
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getSongsFromDB(): Promise<Song[]> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(SONGS_STORE, "readonly");
    const store = tx.objectStore(SONGS_STORE);
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result as Song[]);
    request.onerror = () => reject(request.error);
  });
}

export async function clearSongsFromDB(): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(SONGS_STORE, "readwrite");
    const store = tx.objectStore(SONGS_STORE);
    store.clear();
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export function deleteOfflineDB(): Promise<void> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.deleteDatabase(DB_NAME);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
    req.onblocked = () => reject(new Error("IndexedDB delete blocked by open connection"));
  });
}
